<kilowant-header title="Login credentials" [isHome]="true" [linkHome]="previousUrl"></kilowant-header>
<div class="wrapper-main-public-area">
    @if (!operationCompleted && showForm ) {
    <div class="form thick" style="margin-top: calc(50vh - 170px)">
        <div class="mt-20 mb-20"><b>Your login:</b> {{login}}</div>
        <input type="password" name="Password" class="required" value=" " (input)="resetError()" [type]="passwordType"
               [(ngModel)]="password" placeholder="New password" />
        <div class="password-holder" (click)="showPassword(1)">
            <i [class]="(passwordType=='password')?'password-show':'password-hide'"></i>
        </div>
        <input type="password" name="Password2" class="required" value=" " (input)="resetError()" [type]="passwordType2"
               [(ngModel)]="password2" placeholder="New password (confirm)" />
        <div class="password-holder" (click)="showPassword(2)">
            <i [class]="(passwordType2=='password')?'password-show':'password-hide'"></i>
        </div>
        @if (this.errorY().showError()) {
        <div class="error-block">{{errorY().error}}</div>
        }
        <div class="d-flex">
            <button (click)="sendForm()" class="auto loginBtnsBorder f14">
                SET PASSWORD
            </button>
        </div>
    </div>
    }

    @if (operationCompleted ) {
    <div class="form text-block" style="margin-top: calc(50vh - 170px)">
        The login credentials has been completed.
    </div>
    }
</div>